import { useWorkflowRunStory } from '@Hooks/AgenticOrchestrator/useWorkflowStory';
import { Card } from '@synqo/frontend-component-library';
import { WorkflowStepList } from '../WorkflowStepList';

/** The run as a business user reads it. The step table below is the technical drill-down. */
export function WorkflowRunStoryCard({ workflowRunId }: { workflowRunId: string }) {
    const { view, error } = useWorkflowRunStory(workflowRunId);

    if (error || !view) {
        return null;
    }

    return (
        <Card name="Story" label="Ablauf">
            <WorkflowStepList steps={view.steps} mode={view.mode} />
        </Card>
    );
}
